export default {
  // HOST_URL2: 'https://192.168.1.42/api/',
   //  HOST_URL2: `http://localhost:5270/api/`,
    //HOST_URL: 'http://localhost:5270/api/',

       HOST_URL2: 'https://csadmsapi.mssplonline.com/api/',
     HOST_URL: 'https://csadmsapi.mssplonline.com/api/'

//       HOST_URL2: 'https://securedmsapi.mssplonline.com/api/',
//     HOST_URL: 'https://securedmsapi.mssplonline.com/api/'
// }


}
